import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GS1NotificationLevel, GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, tap } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { environment } from '@env/environment';
import { AllSEPAMandates } from '@models/mandate.model';

@Injectable({ providedIn: 'root' })
export class MandatService {
  __URL_API__ = `${environment.URL_API}`;

  private http = inject(HttpClient);
  private notifications = inject(GS1NotificationService);
  private translate = inject(TranslateService);

  createMandate(IBAN: string, PhoneNumber: string, Email: string): Observable<void> {
    const body: any = { IBAN, PhoneNumber, Email };
    body.RedirectUrlOK = `${environment.URL_Front}entreprise/moyens-de-paiement/SSPOK`;
    body.RedirectUrlNOK = `${environment.URL_Front}entreprise/moyens-de-paiement/SSPNOK`;
    return this.http.post<string>(this.__URL_API__ + 'api/Mandate/CreateMandate', body).pipe(
      take(1),
      tap((SSPUrl) => (window.location.href = SSPUrl)),
      catchError((err) => {
        this.notifications.addNotification(this.translate.instant('Company.SEPA.form.error-get-mandat'), 'error');
        console.error(err);
        return of(null);
      })
    ) as unknown as Observable<void>;
  }

  getMandates(): Observable<AllSEPAMandates> {
    return this.http.get<AllSEPAMandates>(this.__URL_API__ + 'api/Mandate/GetMandates').pipe(
      catchError((err) => {
        this.notifications.addNotification(this.translate.instant('GlobalErrors.default'), 'error');
        console.error(err);
        return of(null);
      })
    );
  }

  updateMandate(BIC: string, IBAN: string): Observable<AllSEPAMandates> {
    return this.http.patch<AllSEPAMandates>(this.__URL_API__ + 'api/Mandate/UpdateMandate', { IBAN, BIC }).pipe(
      take(1),
      tap(() => this.handleSuccess('Company.SEPA.modify.notif-success')),
      catchError((err) => {
        this.notifications.addNotification(this.translate.instant('Company.SEPA.modify.notif-error'), 'error');
        console.error(err);
        return of(null);
      })
    );
  }

  revocMandate(): Observable<AllSEPAMandates> {
    return this.http.post<AllSEPAMandates>(this.__URL_API__ + 'api/Mandate/RevoqueMandate', null).pipe(
      take(1),
      tap(() => this.handleSuccess('Company.SEPA.Revoq.notif-success')),
      catchError((err) => {
        this.notifications.addNotification(this.translate.instant('Company.SEPA.Revoq.notif-error'), 'error');
        console.error(err);
        return of(null);
      })
    );
  }

  handleSuccess(message: string, level: GS1NotificationLevel = 'success') {
    this.notifications.addNotification(this.translate.instant(message), level);
  }
}
